export default {
  guide: "https://pxboss.xiaohebang.cn/system/material/parent/main/guide.png",
  avatarDefault:"https://pxboss.xiaohebang.cn/system/material/pc/etms-image/avatarDefault.png"
};



// WEBPACK FOOTER //
// ./src/api/img.js